import authServerApi from "./authServerApi"
import { put, call, select } from "redux-saga/effects"
import store from "store"
import { browserHistory } from "react-router"
import { DckActionTypes } from "dck-redux"

export const LOGIN = "LOGIN"
export const IS_USER_AUTHENTICATED = "IS_USER_AUTHENTICATED"
export const REFRESH_TOKEN = "REFRESH_TOKEN"
export const GET_USER = "GET_USER"
export const ADD_USER = "ADD_USER"
export const UPDATE_USER = "UPDATE_USER"
export const DELETE_USER = "DELETE_USER"
export const GET_USER_ROLES = "GET_USER_ROLES"
export const RESET_USER_PASSWORD = "RESET_USER_PASSWORD"
export const GET_USER_LOCALES = "GET_USER_LOCALES"
export const UPLOAD_UPDATE = "UPLOAD_UPDATE"
export const UPDATE_LIST = "UPDATE_LIST"

const getCheckAuthProcess = state =>
  state.dck.processes.getIn([DckActionTypes.CHECK_AUTHENTICATED, "running"]) ||
  null

export function* makeAuthRequest(requestType, data) {

  const sessionData = store.get("sessionData")

  switch (requestType) {

    case LOGIN: {
      const result = yield call(authServerApi.login, data)
      if (result.code === 200) {
        return result.data
      }
      else {
        throw new Error(result.data.message ? result.data.message : result.data.error_description)
      }
    }

    case IS_USER_AUTHENTICATED: {
      return yield call(isUserAuthenticated, sessionData)
    }

    case GET_USER: {
      const result = yield call(makeRequest, authServerApi.getUser, {
        userId: data.userId,
        accessToken: sessionData.access_token
      })

      return result
    }

    case ADD_USER: {
      const result = yield call(makeRequest, authServerApi.createUser, {
        accessToken: sessionData.access_token,
        userData: {
          username: data.username,
          name: data.name,
          userRole: data.userRole,
          locale: data.locale,
          organizationId: data.organizationId,
        }
      })

      console.log("add user result=" + JSON.stringify(result))
      return result
    }
  
    case DELETE_USER: {
      const result = yield call(makeRequest, authServerApi.deleteUser, {
        userId: data.userId,
        accessToken: sessionData.access_token
      })

      return result
    }

    case UPDATE_USER: {
      const result = yield call(makeRequest, authServerApi.updateUser, {
        accessToken: sessionData.access_token,
        userData: {
          id: data.id,
          username: data.username,
          name: data.name,
          userRole: data.userRole,
          locale: data.locale,
          organizationId: data.organizationId
        }
      })

      return result
    }

    case RESET_USER_PASSWORD: {
      const result = yield call(makeRequest, authServerApi.resetUserPassword, {
        userId: data.userId,
        accessToken: sessionData.access_token
      })

      return result
    }

    case GET_USER_ROLES: {
      const result = yield call(makeRequest, authServerApi.getUserRoles, {
        accessToken: sessionData.access_token
      })

      return result
    }
    case GET_USER_LOCALES: {
      const result = yield call(makeRequest, authServerApi.getUserLocales, {
        accessToken: sessionData.access_token
      })

      return result
    }

    default: {
      new Error("Unrecognized request:" + requestType)
    }
  }
}

function* makeRequest(request, data, sessionData) {

  const result = yield call(request, data)
  const checkUserSession = yield select(getCheckAuthProcess)

  if (result.error === "invalid_token" && checkUserSession !== true) {
    yield call(browserHistory.push, "/sign-out")
  }

  if(result.code === 200) {
    return result.data
  } else {
    throw result.message
  }
}

function* isUserAuthenticated(sessionData) {
  if (
    sessionData !== undefined &&
    sessionData.access_token !== undefined &&
    sessionData.refresh_token !== undefined &&
    sessionData.authorities !== undefined
  ) {

    const result = yield call(isAccessTokenValid, sessionData.access_token)

    if (result) {

      console.log("Access token is valid.")
      yield put({
        type: DckActionTypes.INITIALIZE_USER_SESSION,
        sessionData: sessionData,
        authenticated: true
      })

      return true
    }
    else {
      const refreshTokenResult = yield call(
        refreshAccessToken,
        sessionData.refresh_token
      )

      if (
        refreshTokenResult !== undefined &&
        refreshTokenResult.access_token !== undefined &&
        refreshTokenResult.refresh_token !== undefined &&
        refreshTokenResult.authorities !== undefined
      ) {

        console.log("Refresh token is valid")
        yield put({
          type: DckActionTypes.INITIALIZE_USER_SESSION,
          sessionData: refreshTokenResult,
          authenticated: true
        })

        store.set("sessionData", refreshTokenResult)

        return true
      }
    }
  }

  yield put({
    type: DckActionTypes.INITIALIZE_USER_SESSION,
    sessionData: {},
    authenticated: false
  })

  store.set("sessionData", {})

  return false
}

function* isAccessTokenValid(accessToken) {

  if (accessToken !== undefined) {
    try {
      const result = yield call(authServerApi.isAccessTokenValid, {
        accessToken: accessToken
      })
      return result === true
    } catch (error) {
      console.log("Error when check access token:" + error)
    }
  }
}

function* refreshAccessToken(refreshToken) {

  if (refreshToken !== undefined) {
    try {
      const result = yield call(authServerApi.refreshAccessToken, {
        refreshToken: refreshToken
      })

      if (result !== false) {
        const sessionData = {
          access_token: result.data.access_token,
          refresh_token: result.data.refresh_token
        }

        return sessionData
      }
    } catch (error) {
      console.log("Error when try to refresh access token:" + error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/authRequest.js